"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OmnichannelMessagePrinter = void 0;
var SupportedAdaptiveCards_1 = require("./interfaces/SupportedAdaptiveCards");
var utilities_1 = require("../utilities");
var OmnichannelMessagePrinter = /** @class */ (function () {
    function OmnichannelMessagePrinter() {
    }
    OmnichannelMessagePrinter.printify = function (message) {
        var _a;
        var result = {};
        if (message) {
            result.id = message.id;
            result.tags = message === null || message === void 0 ? void 0 : message.tags;
            result.bot = ((_a = message === null || message === void 0 ? void 0 : message.tags) === null || _a === void 0 ? void 0 : _a.find(function (tag) { return tag === 'public'; })) ? false : true;
            result.card = Object.values(SupportedAdaptiveCards_1.SupportedAdaptiveCards).some(function (type) { var _a; return (_a = message === null || message === void 0 ? void 0 : message.content) === null || _a === void 0 ? void 0 : _a.includes(type); });
            if (!result.card && (message === null || message === void 0 ? void 0 : message.content)) {
                result.content = (0, utilities_1.messageContentMetadata)(message === null || message === void 0 ? void 0 : message.content);
            }
            result.created = message.timestamp;
        }
        return result;
    };
    return OmnichannelMessagePrinter;
}());
exports.OmnichannelMessagePrinter = OmnichannelMessagePrinter;
//# sourceMappingURL=OmnichannelMessagePrinter.js.map